import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "crm:grid crm:grid-cols-3 crm:content-center crm:gap-4 crm:justify-items-start crm:bg-white crm:py-2 crm:px-4" }
const _hoisted_2 = {
  key: 0,
  class: "crm:content-center"
}
const _hoisted_3 = {
  key: 1,
  class: "crm:justify-self-center crm:content-center"
}
const _hoisted_4 = { class: "crm:flex crm:justify-center crm:py-4 crm:text-center crm:items-center" }
const _hoisted_5 = { class: "crm:mx-2 crm:p-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "crm:flex crm:items-center"
}
const _hoisted_8 = { class: "crm:mx-2 crm:p-2" }

import {reactive, inject, watch} from "vue";


export default {
  __name: 'BaseTableBackendPagination',
  setup(__props) {

/**
 * @doc Renderizza e gestisce la paginazione di una tabella
 * @requires BaseTableBackend.vue
 */
const paginationRef = reactive({
  totalPages: 0,
  currentPage: 1,
  pageToStart: 0,
  pageToEnd: 0,
  itemsPerPage: 10,
  pageToShow: 3
})
const $L_ = inject('$L_');
const totalDataItems = inject('totalDataItems')
const isEseguiPaginazione = inject('isEseguiPaginazione')
const updateIsEseguiPaginazione = inject('updateIsEseguiPaginazione')
const updateItemsPerPage = inject('updateItemsPerPage')
const eseguiAjax = inject('eseguiAjax')
const updateAjaxParams = inject('updateAjaxParams')
const datiTabellaDefault = inject('datiTabellaDefault')
const updateTabella = inject('updateTabella')
const httpParams = inject('httpParams')

watch(isEseguiPaginazione, (newValue) => {
  if(newValue) {
    eseguiPaginazione(1)
  }
}, {deep: true, immediate: true})

/**
 * Aziona il cambio di pagina
 * - Riaggiorna il calcolo per mostrare graficamente i numerini della paginazione
 * - Se non si tratta di una tabella in modalità paginazione front, aggiorna i parametri con la nuova pagina cliccata
 * ed esegue la chiamata ajax.
 * Sia il metodo di aggiornamento dei parametri che per effettuare la chiamata, sono prelevati con l'inject dal componente padre
 * BaseTableBackend.vue
 * @param page
 * @return {Promise<void>}
 */
async function changePage(page) {
  await eseguiPaginazione(page);
  if(httpParams['isFrontendAction'] === undefined || !httpParams['isFrontendAction']) {
    await updateAjaxParams({pagination: {currentPage: page}});
    await eseguiAjax();
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
}

/**
 * Riaggiorna il calcolo per mostrare graficamente i numerini della paginazione
 * In base al pageToShow settato, mostra solo quel numero di pagine seguito dai ...
 * Ex.
 * Se siamo a pagina 1 e ho un pageToShow a 4 e un numero totale pagine di 16
 * mostrerò 1 2 3 4 ... 16
 * @param page
 * @return {Promise<void>}
 */
async function eseguiPaginazione(page) {
  paginationRef.currentPage = page;
  paginationRef.itemsPerPage = updateItemsPerPage.value ? updateItemsPerPage.value : 10
  let offset = paginationRef.itemsPerPage * page;
  let start = page === 1 ? 0 : paginationRef.itemsPerPage * (page - 1);
  paginationRef.totalPages = Math.ceil((totalDataItems.value) / paginationRef.itemsPerPage);
  paginationRef.pageToStart =
      page - paginationRef.pageToShow <= 0 ? 1 : page - paginationRef.pageToShow;
  paginationRef.pageToEnd =
      page + paginationRef.pageToShow > paginationRef.totalPages
          ? paginationRef.totalPages
          : page + paginationRef.pageToShow;

  if(httpParams['isFrontendAction'] !== undefined && httpParams.isFrontendAction) {
    let dati = $L_.cloneDeep(datiTabellaDefault.value);
    let datiToSend = dati.slice(start, offset);
    updateTabella(datiToSend)
  } else {
    updateIsEseguiPaginazione(false);
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (paginationRef.totalPages > 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Pagina " + _toDisplayString(paginationRef.currentPage) + " di " + _toDisplayString(paginationRef.totalPages), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (paginationRef.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" render torna alla prima pagina e torna alla pagina precedente "),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "crm:mr-1",
                onClick: _cache[0] || (_cache[0] = $event => (changePage(1)))
              }, [
                _createCommentVNode(" @slot personalizzazione icona "),
                _renderSlot(_ctx.$slots, "pagination-first-icon", {}, () => [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-angle-double-left crm:cursor-pointer" }, null, -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("span", {
                class: "crm:mr-1",
                onClick: _cache[1] || (_cache[1] = $event => (changePage(paginationRef.currentPage - 1)))
              }, [
                _createCommentVNode(" @slot personalizzazione icona "),
                _renderSlot(_ctx.$slots, "pagination-prev-icon", {}, () => [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-angle-left crm:cursor-pointer" }, null, -1 /* CACHED */))
                ])
              ])
            ], 512 /* NEED_PATCH */), [
              [_vShow, paginationRef.currentPage > 1]
            ]),
            _createCommentVNode(" render N page "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationRef.pageToEnd, (n, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (n >= paginationRef.pageToStart)
                  ? (_openBlock(), _createElementBlock("div", {
                      onClick: $event => (changePage(n)),
                      key: `page-${index}`,
                      class: _normalizeClass(["crm:mr-1 crm:cursor-pointer crm:p-2 crm:hover:font-bold", { 'crm:rounded-xs crm:bg-[#E7F5FF] crm:font-bold': n === paginationRef.currentPage }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(n), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_6))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 256 /* UNKEYED_FRAGMENT */)),
            (paginationRef.totalPages !== paginationRef.pageToEnd)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createTextVNode(" ... ", -1 /* CACHED */)),
                  _createElementVNode("span", {
                    onClick: _cache[2] || (_cache[2] = $event => (changePage(paginationRef.totalPages))),
                    class: "crm:ml-1 crm:cursor-pointer crm:p-2 crm:hover:font-bold"
                  }, _toDisplayString(paginationRef.totalPages), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" render vai all'ultima pagina e vai alla pagina successiva "),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: "crm:ml-1",
                onClick: _cache[3] || (_cache[3] = $event => (changePage(paginationRef.currentPage + 1)))
              }, [
                _createCommentVNode(" @slot personalizzazione icona "),
                _renderSlot(_ctx.$slots, "pagination-next-icon", {}, () => [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-angle-right crm:cursor-pointer" }, null, -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("span", {
                class: "ms-1",
                onClick: _cache[4] || (_cache[4] = $event => (changePage(paginationRef.totalPages)))
              }, [
                _createCommentVNode(" @slot personalizzazione icona "),
                _renderSlot(_ctx.$slots, "pagination-last-icon", {}, () => [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-angle-double-right crm:cursor-pointer" }, null, -1 /* CACHED */))
                ])
              ])
            ], 512 /* NEED_PATCH */), [
              [_vShow, paginationRef.currentPage < paginationRef.totalPages]
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}